module.exports = __webpack_public_path__ + "static/terra-plus-cover-6e77a1eed222eef6329a8b543ffc7d5e.mp4";